import { render, staticRenderFns } from "./accessibility.vue?vue&type=template&id=16638dc0&"
import script from "./accessibility.vue?vue&type=script&lang=js&"
export * from "./accessibility.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports